import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-4',
    addresses: 'flex flex-col gap-3',
    address:
      'hover:bg-blue-light hover:border-blue-light flex cursor-pointer gap-2 border border-[#BFD7F2] px-4 py-6 transition-colors duration-200',
    icon: 'mt-0.5 size-6 min-w-6 text-[#BFD7F2]',
    content: 'flex flex-col gap-2',
    title: 'heading-m-bold',
    street: 'heading-s',
    phone: 'heading-m-bold cursor-pointer text-black'
  },
  variants: {
    selected: {
      true: {
        address: 'border-blue-light bg-blue-light'
      }
    }
  }
});
